<template>
    <div class="m-editDialog">
        <el-form ref="forms" class="search-form"  :model="forms" :rules="rules" label-width="100px">
                <el-scrollbar style="height: 100%;width: 100%;" wrapClass="scrollView" ref="conScroll">
                <el-form-item prop="roleName" label="角色名称">
                    <el-input placeholder="请输入角色名称" v-model="forms.roleName" clearable class="w_360"></el-input>
                </el-form-item>
                <el-form-item prop="remark" label="角色备注">
                    <el-input placeholder="请输入角色备注" v-model="forms.remark" clearable class="w_360"></el-input>
                </el-form-item>
                <el-form-item prop="permissionIds" label="权限设置">
                    <!-- <el-input  v-model="forms.permissionIds" clearable class="w_360 hide"></el-input> -->
                    <div class="m-tree">
                        <el-tree ref="tree"
                            :data="permsList"
                            show-checkbox
                            node-key="id"
                            :default-expanded-keys="forms.permissionIds"
                            :default-checked-keys="forms.permissionIds"
                            :props="defaultProps">
                        </el-tree>
                    </div>
                </el-form-item>
            </el-scrollbar>
        </el-form>
        
        <div slot="footer" class="dialog-footer">
            <el-button @click.stop="close" class="btnCancel">取 消</el-button>
            <el-button type="primary" @click.stop="submit" class="btnNew" :loading="loading">确 定</el-button>
        </div>
    </div>
    
</template>

<script>
import API from '@/fetch/api'
import merge from 'webpack-merge'

export default {
    props: ['permsList', 'editType', 'initData'],
    data(){
        return {
            forms: {
                roleName: '',
                remark: '',
                permissionIds: []
            },
            defaultProps: {
                children: 'childList',
                label: 'permissionName',
                disabled: 'disabled'
            },
            loading: false,
            rules: {
                roleName: [
                    { required: true, message: '请输入角色名称', trigger: 'blur' },
                ],
                remark: [
                    { required: false, message: '请输入角色备注', trigger: 'blur' },
                ],
                permissionIds: [
                    { required: true, message: '请设置权限' },
                ],
            }
        }
    },
    created(){
        if(this.editType == 'edit') this.getInit();
    },
    mounted(){
        
    },
    methods: {
        getInit(){
            let vm = this, needDelArr = [];
            vm.initData.permissionIds.map((v, i) => {
                vm.diguiquchu(
                    vm.initData.permissionIds,
                    vm.permsList,
                    v,
                    i,
                    needDelArr
                );
            });
            vm.initData.permissionIds = vm.initData.permissionIds.filter(id=>needDelArr.indexOf(id) == -1);
            vm.$set(vm, 'forms', merge(vm.forms, vm.initData));
        },
        diguiquchu(datas, arr, v, i, needdelarr) {
            let vm = this;
            //递归找出半选中的数据
            arr.map((item, index) => {
                if (item.id == v && item.childList) {
                // datas.splice(i, 1);//因为每次截取会改变原数组，所以不能这样
                needdelarr.push(v);
                vm.diguiquchu(datas, item.childList, v, i, needdelarr);
                } else if (item.id != v && item.childList) {
                vm.diguiquchu(datas, item.childList, v, i, needdelarr);
                }
            });
        },
        close(){
            this.$emit('close');
        },
        submit(){
            let vm = this, url = '', text = '';
            let params = merge(vm.forms, {});
            // 获取选中和半选中的数据
            let checked = vm.$refs.tree.getCheckedKeys();
            checked = checked.concat(vm.$refs.tree.getHalfCheckedKeys());
            vm.forms.permissionIds = checked;
            params.permissionIds = String(checked);
            vm.$refs.forms.validate((valid) => {
                if(!valid) return;
                vm.loading = true;
                url = vm.editType == 'add' ? '/merchant/role/add' : '/merchant/role/edit';
                text = vm.editType == 'add' ? '新增' : '编辑';
                API.http({ url, type: 'post',
                    params: params
                }).then(res => {
                    vm.loading = false;
                    if(res.code == "200") {
                        vm.$showAlert(`${text}成功`, "success");
                        vm.$emit('ok');
                        return;
                    }
                    vm.$showAlert(res.message || `${text}成功`, "error");
                }).catch(error => {
                    vm.loading = false;
                    vm.$showAlert(res.message || `${text}成功`, "error");
                })
            })
        },
    }
}
</script>

<style lang="scss">
@import '../../../style/variable';
    .m-editDialog{
        
        .search-form{
            .el-scrollbar__wrap{
                overflow-x: hidden;
            }
            background-color: $c1;
            margin: 10px 10px 20px;
            height: 460px;;
            border: 1px solid $c26;
            border-radius: 4px;
            .m-tree{
                width: 360px;
                border: 1px solid $c25;
                border-radius: 4px;
                .el-tree .el-tree-node__content{
                    min-height: 30px;
                    .el-tree-node__label{
                        margin-left: 8px;
                    }
                }
            }
        }
        .dialog-footer{
            background-color: $c1;
            padding: 20px;
            text-align: center;
        }
    }
</style>